import { render } from "./downloadAPK.vue?vue&type=template&id=428f1391"
import script from "./downloadAPK.vue?vue&type=script&lang=js"
export * from "./downloadAPK.vue?vue&type=script&lang=js"

import exportComponent from "D:\\myWorkspace\\CoreServiceAzure\\CoreServiceCloud\\MyNews\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__